import { Injectable } from '@angular/core';
import { ApiIndexResult, ApiService, ListOptions } from '@capturum/api';
import { Installer } from '@features/installers/models/installer.model';
import { map, Observable } from 'rxjs';
import { Timeline } from '@features/leads/models/timeline.model';
import { unwrapResult } from '@core/operators/unwrap-result.operator';

@Injectable({
  providedIn: 'root',
})
export class InstallerService extends ApiService<Installer> {
  protected endpoint = 'installer';

  public getInstallerListWithFiveNearest(leadId: string, options: ListOptions): Observable<ApiIndexResult<Installer>> {
    let url = `/lead/${leadId}/nearest-installers`;

    if (options) {
      url += this.getOptionsQuery(options);
    }

    return this.apiHttp.get<Installer[]>(url).pipe(
      map((result) => {
        return {
          data: result,
          meta: {},
        } as ApiIndexResult<Installer>;
      })
    );
  }

  public getTimeline(installerId: string): Observable<Timeline[]> {
    return this.apiHttp.get<Timeline[]>(`/${this.endpoint}/${installerId}/timeline`);
  }

  public uploadInstallers(data: any): Observable<any> {
    let headers = this.apiHttp.getHeaders();

    if (data['file']) {
      headers = headers.delete('content-type').append('enctype', 'multipart/form-data');

      data = this.toFormData({
        excel: data.file,
      });
    }

    return this.apiHttp.post(`/installer/excel`, data, { headers });
  }

  public sendReviewByIncomingType(actionType: string, installerId: string): Observable<null> {
    return this.apiHttp.post(`/installer/${installerId}/${actionType}`, {});
  }

  public updateOptedOut(customerId: string): Observable<any> {
    const url = `/${this.endpoint}/${customerId}/opt-out`;

    return this.apiHttp.put(url, {}).pipe(unwrapResult());
  }
}
